export default __webpack_public_path__ + "static/media/fakebackground.f09f96f6.svg";